import type { FinanceReport } from '../../../shared/types';
import { Tabs } from '../../components/primitives';
import { fyList } from './helpers';
import { setSelectedFY, useSelectedFY } from './hooks';

export function FYSwitcher({ report, fyKey }: { report: FinanceReport; fyKey: string }) {
  const fy = useSelectedFY(fyKey);
  const options = fyList(report).map((k) => ({ value: k, label: k }));
  if (options.length === 0) return null;
  return (
    <div className="fy-select">
      <Tabs options={options} value={fy} onChange={setSelectedFY} />
    </div>
  );
}
